import store from './store';
import { SET_ANALYTICS } from './features/analytics/actionTypes'

export const SendEvent = (data: any): void => {
    const state = store.analytics
    const d = getCommon();
    const d2 = getUniqueValuesFromObject({ ...d, ...data }, state);
    const final = { ...d2, ...{event:data.event} };
    
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push(final);
    store.dispatch({ type: SET_ANALYTICS, payload: final });
    console.log(final);
}
export const getUniqueValuesFromObject = (o: any, o2: any): any => {
    if (typeof o2 == 'undefined') return o;
    const result: any = {};
    for (const k in o) {
        // console.log('comparing ', o[k], o2[k]);
        if (typeof o[k] != 'object'){
            // console.log('normal value');
            if (o2[k] != o[k]) {
                // console.log('is unique');
                result[k] = o[k];
            }
            // else {
                // console.log('not unique');
            // }
        }
        else {
            // console.log('object value')
            const o3 = getUniqueValuesFromObject(o[k], o2[k]);
            for(const prop in o3) {
                // console.log('has unique vals in object') 
                result[k] = o3;
                // result[k] = {...o[k], ...o2[k]};
                break;
            }
        }
    }
    return result;
}
export const getCommon = (): any => {
    return {

    };
}

export default SendEvent